'use client';
import { jsxs } from 'react/jsx-runtime';
import cn from 'classnames';
import styles from './index.module.css.js';

const Location = ({ item, className }) => {
    const { geo } = item;
    const town = geo.town?.value;
    const cityShortName = geo.city?.shortName;
    if (!town || !cityShortName) {
        return null;
    }
    return (jsxs("span", { className: cn('caption small book', styles.location, className), children: [town, " (", cityShortName, ")"] }));
};

export { Location };
//# sourceMappingURL=index.js.map
